import {
	ARCHIVING_EXPORTS_SHARED_METADATA,
	IArchivingExportsSharedMetadata
}                                    from '@app/modules/archiving/config/archiving-exports-shared.config';
import { ArchivingExportStatusEnum } from '@app/modules/archiving/models/archiving-export.model';
import { APP_CONFIG }                from '@appConfig/_app-config_master';
import { DeviceTypeEnum }            from '@appConfig/media-config';
import { ITabContent }               from '@core/interfaces/common.interfaces';
import { SortOrderEnum }             from '@shared/list-operations/components/sort-filter/sort-filter.model';
import { LIST_OPERATIONS_METADATA }  from '@shared/list-operations/config/list-operations.config';
import {
	FilterIdentifiersEnum,
	FilterTypes
}                                    from '@shared/list-operations/model/filter.model';
import {
	IListOperationsConfig,
	ListOperationsIdentifierEnum
}                                    from '@shared/list-operations/model/list-operations.model';
import { PagingModeEnum }            from '@shared/list-operations/model/paging.model';

interface IArchivingExportMetadata extends IArchivingExportsSharedMetadata {

	entityId: string;

	storeId: string;

	entity: {
		dateFormat: Intl.DateTimeFormatOptions;
	};

	details: {
		dateFormat: Intl.DateTimeFormatOptions;
		internalTabContent: ITabContent[];
	};

	listOperations: IListOperationsConfig;

	i18n: {
		basepath: string;
		page: string;
		entity: string;
		details: string;
	};
}

export const ARCHIVING_EXPORT_METADATA: IArchivingExportMetadata = {
	entityId: APP_CONFIG.archivingExport.entityId,
	storeId: APP_CONFIG.archivingExport.store.id,
	extendAllowedCount: ARCHIVING_EXPORTS_SHARED_METADATA.extendAllowedCount,
	extendMaxAvailableDays: ARCHIVING_EXPORTS_SHARED_METADATA.extendMaxAvailableDays,
	warningStatusDaysLeftLimit: ARCHIVING_EXPORTS_SHARED_METADATA.warningStatusDaysLeftLimit,
	entity: {
		dateFormat: { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }
	},
	details: {
		dateFormat: { day: '2-digit', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false },
		internalTabContent: [
			{
				key: 'id',
				order: 1,
				i18nPath: 'archivingExport.page.details.id',
				addSpaceToPrevious: false,
				copyClipboard: true,
				showOnDevices: [ DeviceTypeEnum.MOBILE, DeviceTypeEnum.TABLET, DeviceTypeEnum.DESKTOP ]
			}
		]
	},
	listOperations: {
		id: ListOperationsIdentifierEnum.BUSINESS_PREMISES_DETAIL_PAGE_ARCHIVE_EXPORTS,
		pagingData: {
			mode: PagingModeEnum.Light,
			continuesPagesMode: false,
			defaultValues: {
				pageSize: LIST_OPERATIONS_METADATA.default.paging.pageSize ?? 20,
				pageNumber: LIST_OPERATIONS_METADATA.default.paging.pageNumber ?? 0
			}
		},
		sortData: [
			{
				name: 'created',
				i18nPath: 'shared.forms.created.label',
				defaultActive: true,
				sortOrder: SortOrderEnum.DESC
			},
			{
				name: 'status',
				i18nPath: 'shared.forms.status.label'
			}
		],
		filterData: [
			{
				order: 1,
				isRendered: true,
				isDisabled: false,
				filterId: FilterIdentifiersEnum.CREATED_DATE,
				type: FilterTypes.FILTER_DATE_RANGE_PICKER_TYPE,
				i18nPath: 'archivingExport.filter.created',
				service: 'createdDate',
				prefix: 'archivingExport_',
				properties: {
					dateInputFormat: { year: 'numeric', month: 'short', day: '2-digit' }
				}
			},
			{
				order: 2,
				isRendered: true,
				isDisabled: false,
				filterId: FilterIdentifiersEnum.STATUS,
				type: FilterTypes.FILTER_LIST_TYPE,
				i18nPath: 'archivingExport.filter.status',
				items: [
					{ value: ArchivingExportStatusEnum.READY, i18nPath: 'shared.status.ready' },
					{ value: ArchivingExportStatusEnum.PENDING, i18nPath: 'shared.status.pending' },
					{ value: ArchivingExportStatusEnum.COLLECTING, i18nPath: 'shared.status.collecting' },
					{ value: ArchivingExportStatusEnum.ERROR, i18nPath: 'shared.status.error' }
				]
			}
		]
	},
	i18n: {
		basepath: APP_CONFIG.archivingExport.i18nPath,
		page: 'page',
		entity: 'entity',
		details: 'details'
	}
};
